"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_hook_form_1 = require("react-hook-form");
const react_redux_1 = require("react-redux");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const native_base_1 = require("native-base");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const useDevice_1 = require("../../hooks/useDevice");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const character_1 = require("../../services/character");
const document_1 = require("../../services/document");
const document_2 = require("../../store/selectors/document");
const document_3 = require("../../slices/document");
const AppFormLabel_1 = require("../AppText/AppFormLabel");
const GradientButton_1 = require("../GradientButton");
const TextArea_1 = require("../InputForm/TextArea");
const CharacterImageWarn_1 = __importDefault(require("../MessageWarn/CharacterImageWarn"));
const CloseButton_1 = __importDefault(require("../AppButton/CloseButton"));
const KeyboardScrollView_1 = __importDefault(require("../ui-components/KeyboardScrollView"));
const ImageModelsButton_1 = __importDefault(require("./ImageModelsButton"));
const document_4 = require("../../helper/document");
const AppLoader_1 = __importDefault(require("../AppLoader"));
const AppText_1 = require("../AppText");
const RegenerateImageModal = ({ isOpen, onClose, document }) => {
    const { control, handleSubmit, getValues, formState: { errors } } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            prompt: (0, document_4.getMarkdownContent)(document.summaryResponse, 'Image Prompt'),
            styleString: "Photograph", // Default Value
        }
    });
    const { request } = (0, useRequest_1.default)();
    const isImageRegenerating = (0, react_redux_1.useSelector)(document_2.selectIsImageLoading);
    const [documentCharacter, setDocumentCharacter] = (0, react_1.useState)();
    const [imageModel, setImageModel] = (0, react_1.useState)({
        modelId: 'black-forest-labs/flux-dev',
        styleString: 'A photorealistic rendering of ',
        aspectRatio: '16:9',
    });
    const [regenerateImageHit, setRegenerateImageHit] = (0, react_1.useState)(0);
    const leftImagesAttempts = (0, react_1.useMemo)(() => (constants_1.MAX_DOC_IMAGE_REGENERATION_LIMIT - document.images.length), [document]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { deviceHeight } = (0, useDevice_1.useDevice)();
    const toast = (0, native_base_1.useToast)();
    (0, react_1.useEffect)(() => {
        let wasUnmounted = false;
        const fetchCharacter = () => {
            request(character_1.getCharacterProfile, document.character_id).then((characterResponse) => {
                if (characterResponse && !wasUnmounted) {
                    const character = characterResponse.data;
                    setDocumentCharacter(characterResponse.data);
                    setImageModel((prevImageModel) => ({
                        ...prevImageModel,
                        modelId: character.imageModelId,
                        aspectRatio: '16:9',
                        ...character.styleString && { styleString: character.styleString },
                    }));
                }
                ;
            });
        };
        fetchCharacter();
    }, [document, request]);
    const handleRegenerateImage = (0, react_1.useCallback)(() => {
        if (errors.prompt) {
            toast.show({
                description: "Prompt is required",
                placement: "top",
                duration: 3000,
            });
            return;
        }
        if (errors.styleString) {
            toast.show({
                description: "Style is required",
                placement: "top",
                duration: 3000,
            });
            return;
        }
        dispatch((0, document_3.setIsImageRegenerating)(true));
        const formValues = getValues();
        request(document_1.regenerateImage, document, formValues.prompt, imageModel).then((imageResponse) => {
            if (imageResponse) {
                setRegenerateImageHit(regenerateImageHit + 1);
                dispatch((0, document_3.patchDocumentCharacter)({
                    id: document.character_id,
                    changes: {
                        documentImage: imageResponse.urls[imageResponse.urls.length - 1],
                    },
                }));
                onClose();
            }
            dispatch((0, document_3.setIsImageRegenerating)(false));
        });
    }, [
        documentCharacter,
        document,
        imageModel,
        errors,
        regenerateImageHit,
        document_1.regenerateImage,
        onClose,
    ]);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Modal, { visible: isOpen, transparent: true, animationType: isOpen ? 'slide' : 'fade', children: (0, jsx_runtime_1.jsx)(native_base_1.NativeBaseProvider, { children: (0, jsx_runtime_1.jsx)(native_base_1.View, { style: {
                    flex: 1,
                    backgroundColor: `${colors_1.Colors.DARK_700}CC`,
                    justifyContent: "center",
                    alignItems: "center"
                }, children: (0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureHandlerRootView, { style: { width: '100%', alignItems: 'center' }, children: (0, jsx_runtime_1.jsxs)(native_base_1.VStack, { backgroundColor: colors_1.Colors.DARK_600, maxHeight: deviceHeight - 150, maxWidth: 658, width: "90%", padding: 6, borderRadius: 32, overflow: "hidden", children: [(0, jsx_runtime_1.jsx)(AppLoader_1.default, { isLoading: isImageRegenerating, showLoader: true, darkBg: true }), (0, jsx_runtime_1.jsxs)(KeyboardScrollView_1.default, { children: [(0, jsx_runtime_1.jsx)(native_base_1.HStack, { justifyContent: "space-between", alignItems: "center", mb: 3, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.white, fontSize: 20, children: "Regenerate Image" }) }), (0, jsx_runtime_1.jsx)(CharacterImageWarn_1.default, { message: `${leftImagesAttempts
                                            ? `You have ${leftImagesAttempts}`
                                            : 'No'} attempt${leftImagesAttempts !== 1 ? 's' : ''} left to regenerate image`, color: leftImagesAttempts === 1 ? colors_1.Colors.WARNING : "" }), (0, jsx_runtime_1.jsxs)(native_base_1.VStack, { space: 4, mt: 4, children: [(0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, render: ({ field: { onChange, value } }) => ((0, jsx_runtime_1.jsxs)(native_base_1.VStack, { children: [(0, jsx_runtime_1.jsx)(AppFormLabel_1.AppFormLabel, { children: "Prompt" }), (0, jsx_runtime_1.jsx)(TextArea_1.TextAreaForm, { placeholder: "", id: "prompt", onChangeText: onChange, value: value ?? '', multiline: true, numberOfLines: 4, marginTop: 4 })] })), name: "prompt", rules: { required: "Prompt is required" } }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, render: ({ field: { onChange, value } }) => ((0, jsx_runtime_1.jsxs)(native_base_1.VStack, { children: [(0, jsx_runtime_1.jsx)(AppFormLabel_1.AppFormLabel, { mb: 2, children: "Style" }), (0, jsx_runtime_1.jsx)(ImageModelsButton_1.default, { setValue: (styleData) => {
                                                                const { modelId, aspectRatio, imageModel: { name, styleString } } = styleData;
                                                                onChange(name);
                                                                setImageModel({
                                                                    modelId,
                                                                    aspectRatio,
                                                                    styleString,
                                                                });
                                                            }, value: value, selectedStyle: imageModel.styleString, selectedModel: imageModel.modelId, selectedRatio: imageModel.aspectRatio, showAspectRatio: false })] })), name: "styleString", rules: { required: "Style is required" } })] }), (0, jsx_runtime_1.jsx)(native_base_1.VStack, { alignItems: "center", mt: 6, width: "100%", mb: 5, children: (0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: "Regenerate Image", onPress: handleSubmit(handleRegenerateImage), disabled: !leftImagesAttempts, fullWidth: false, style: { width: '100%', } }) })] }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClose: onClose })] }) }) }) }) }));
};
exports.default = (0, react_1.memo)(RegenerateImageModal);
